import { SpotifyClient } from 'umg-cms-js-sdk/src/services/spotify'
import { AppleMusic } from 'umg-cms-js-sdk/src/services/apple'
import { ApplePlayer, SpotifyPlayer, playerFromService } from 'umg-cms-js-sdk/src/player'
import { UmgHlsPlayer } from 'umg-cms-js-sdk/src/player/umg_hls_player'
import { cms } from '@/cms'

const spotify = new SpotifyClient()
const apple = new AppleMusic()

// const applePlayer = new ApplePlayer(apple)
const applePlayer = playerFromService('apple', cms, [apple])
// const spotifyPlayer = new SpotifyPlayer(spotify)
const spotifyPlayer = playerFromService('spotify', cms, [spotify])

const umgHlsPlayer = new UmgHlsPlayer(null, 'dev') // video element and callback is set later

export { spotify, apple, spotifyPlayer, applePlayer, umgHlsPlayer }
